package com.fantasytenis.shared.domain.engagement.usecases

import com.fantasytenis.shared.core.utils.SharedData
import com.fantasytenis.shared.domain.engagement.EngagementRepository
import com.fantasytenis.shared.domain.engagement.entity.EngagementEntity

/**
 * Use case for using the weekly streak saver.
 * Updates SharedData.engagement on success.
 */
class UseStreakSaverUseCase(
    private val repository: EngagementRepository
) {
    suspend operator fun invoke(): Result<EngagementEntity> = runCatching {
        val engagement = repository.useStreakSaver()
        // Update shared state
        SharedData.engagement.value = engagement
        engagement
    }
}
